import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { LocaleTH } from './locales/th/th.locale'
import { LocaleEN } from './locales/en/en.locale'

const resources = {
  th: {
    translation: LocaleTH
  },
  en: {
    translation: LocaleEN
  }
}
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'th',
    interpolation: {
      escapeValue: false
    }
  })

export default i18n